<nav class="mobile-navigation" aria-label="Mobile primary navigation">
    @for (item of navigationItems; track item.path) {
    <a [routerLink]="item.path" routerLinkActive="active" [routerLinkActiveOptions]="activeMatchOptions"
        ariaCurrentWhenActive="page">
        <geaui-icon-v3 [file]="item.icon" [fileSize]="16" [color]="'black'" aria-hidden="true" />
        <span>{{ item.label }}</span>
    </a>
    }
</nav>